import { InjectionToken } from '@angular/core';
import { YaConfig } from '../models/config.model';

export const YA_CONFIG = new InjectionToken<YaConfig>('YA_CONFIG');
